const AdminFooter = () => (
  <div className="cms-admin-footer">
    <span>SmoothBadger CMS</span>
    <span>Part of SmoothBadger</span>
  </div>
);
export default AdminFooter;
